import KeyboardNumbers from './customer/default/keyboardNumbers.component';

export default KeyboardNumbers;
